import { render } from "./the-header-user-menu.vue?vue&type=template&id=0b46d977&ts=true"
import script from "./the-header-user-menu.vue?vue&type=script&lang=ts"
export * from "./the-header-user-menu.vue?vue&type=script&lang=ts"

import "./the-header-user-menu.vue?vue&type=style&index=0&id=0b46d977&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__